import { LanguageCode } from 'common/src/vtj/LanguageCode.enum'
import AetAdditionalSelectionsStep from 'todistukset-ui/src/vtj/components/order-wizard-aet-orderer/AetAdditionalSelectionsStep.react'
import AetContactInfoStep from 'todistukset-ui/src/vtj/components/order-wizard-aet-orderer/AetContactInfoStep.react'
import AetInstructionsStep from 'todistukset-ui/src/vtj/components/order-wizard-aet-orderer/AetInstructionsStep.react'
import AetLastnameChoiceStep from 'todistukset-ui/src/vtj/components/order-wizard-aet-orderer/AetLastnameChoiceStep.react'
import AetOrderCompleteStep from 'todistukset-ui/src/vtj/components/order-wizard-aet-orderer/AetOrderCompleteStep.react'
import AetOrdererInfoStep from 'todistukset-ui/src/vtj/components/order-wizard-aet-orderer/AetOrdererInfoStep.react'
import AetSpouseInfoStep from 'todistukset-ui/src/vtj/components/order-wizard-aet-orderer/AetSpouseInfoStep.react'
import AetSummaryStep from 'todistukset-ui/src/vtj/components/order-wizard-aet-orderer/AetSummaryStep.react'
import {
  validateAdditionalSelectionSteps,
  validateContactInfoFields,
  validateLastnameChoiceFields,
  validateOrdererInfoFields,
  validateOrdererSpouseInfoFields,
} from 'todistukset-common/src/vtj/validation'
import {
  OnClickParams,
  Step,
  StepButtons,
} from 'todistukset-ui/src/vtj/components/order-wizard/OrderWizardStep.type'
import { useSubmitAetOrdererForm } from 'todistukset-ui/src/vtj/stores/actions/aet-orderer-form-actions'
import { refreshSession } from 'todistukset-ui/src/vtj/stores/actions/session-timer-actions'
import PageRoutes from 'todistukset-ui/src/vtj/todistukset-page-routes.enum'
import StepRoutes from 'todistukset-ui/src/vtj/todistukset-step-routes.enum'

// eslint-disable-next-line @typescript-eslint/no-empty-function
function doNothing(): void {}

const refreshOnClick = ({ onSuccess }: OnClickParams): void => {
  refreshSession()
  onSuccess()
}

const getRefreshOnClick = () => refreshOnClick

export function getAetOrdererSteps(): Step[] {
  const steps = [
    {
      name: StepRoutes.AET_INSTRUCTIONS,
      component: AetInstructionsStep,
      validations: [],
      onPrevClick: doNothing,
      useOnNextClick: getRefreshOnClick,
      buttons: StepButtons.NEXT,
    },
    {
      name: StepRoutes.AET_ORDERER_INFO,
      component: AetOrdererInfoStep,
      validations: [validateOrdererInfoFields],
      onPrevClick: refreshOnClick,
      useOnNextClick: getRefreshOnClick,
      buttons: StepButtons.PREV_AND_NEXT,
    },
    {
      name: StepRoutes.AET_SPOUSE_INFO,
      component: AetSpouseInfoStep,
      validations: [validateOrdererSpouseInfoFields],
      onPrevClick: refreshOnClick,
      useOnNextClick: getRefreshOnClick,
      buttons: StepButtons.PREV_AND_NEXT,
    },
    {
      name: StepRoutes.AET_LASTNAME_CHOICE,
      component: AetLastnameChoiceStep,
      validations: [validateLastnameChoiceFields],
      onPrevClick: refreshOnClick,
      useOnNextClick: getRefreshOnClick,
      buttons: StepButtons.PREV_AND_NEXT,
    },
    {
      name: StepRoutes.AET_ADDITIONAL_SELECTIONS,
      component: AetAdditionalSelectionsStep,
      validations: [validateAdditionalSelectionSteps],
      onPrevClick: refreshOnClick,
      useOnNextClick: getRefreshOnClick,
      buttons: StepButtons.PREV_AND_NEXT,
    },
    {
      name: StepRoutes.AET_CONTACT_INFO,
      component: AetContactInfoStep,
      validations: [validateContactInfoFields],
      onPrevClick: refreshOnClick,
      useOnNextClick: getRefreshOnClick,
      buttons: StepButtons.PREV_AND_NEXT,
    },
    {
      name: StepRoutes.AET_SUMMARY,
      component: AetSummaryStep,
      validations: [],
      onPrevClick: refreshOnClick,
      useOnNextClick: useSubmitAetOrdererForm,
      buttons: StepButtons.PREV_AND_SEND,
    },
    {
      name: StepRoutes.AET_ORDER_COMPLETE,
      component: AetOrderCompleteStep,
      validations: [],
      onPrevClick: doNothing,
      useOnNextClick: () => doNothing,
      buttons: StepButtons.NONE,
    },
  ]
  return steps.map((step, index) => {
    return {
      ...step,
      index,
      getPath: (lang = LanguageCode.FI) =>
        `/${lang}/${PageRoutes.AETTODISTUS_ORDERER}/${step.name}`,
    }
  })
}
